import { ApiControllerActionEnum } from './enums/ApiControllerActionEnum'
export class Constants{

  /**
   * List of API Method that required loader on element level
   */
  public static ElementLevelLoaderAPIs():string[] {
    return [ApiControllerActionEnum.GetVehicleReservationPolicy]
  }

}
